import { Outlet } from 'react-router-dom'
import SideBar from '../SideBar'
import Header from '../Header'

const HeadAndSide = () => {

    return (
        <>
            <Header />
            <div className=' w-full relative flex'>
                <div className='w-0 md:w-[20%]'><SideBar /></div>
                <div className='w-full md:w-[80%] mt-5 md:mt-0'><Outlet /></div>
            </div>
        </>
    )
}

export default HeadAndSide